import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonUtil } from '../../../../shared/services/utility/common.service';
import { CommonDataService } from '../../../../shared/services/common-data.service';
import { DatePipe } from '@angular/common';
import { DevicesDashboardService } from '../../devices/devices-dashboard.service';
import { NoUIBlockHttpParams } from '../../../../shared/loader/noUIBlock-httpParam';

@Injectable()
export class PlinksDashboardService {

	constructor(
		private httpClient: HttpClient,
		private commonUtil: CommonUtil,
		private commonData: CommonDataService,
		private datePipe: DatePipe,
		private devicesDashboard: DevicesDashboardService
	) { }

	getPlinks(plink, options) {
		return this.httpClient.post('/plinks/getPlinks', {plink, options}, {
			observe: "body"
		});
	}

	getCachedPlinks(id) {
		return this.httpClient.post('/plinks/getCachedPlinks', {id}, {
			observe: "body"
		});
	}

	getPlinksSettingsInfo(ids) {
		return this.httpClient.post('/plinks/getPlinksSettingsInfo', {ids}, {
			observe: "body"
		});
	}

	savePlinkSettings(stage, plink) {
		return this.httpClient.post('/plinks/savePlinkSettings', {stage, plink}, {
			observe: "body"
		});
	}

	updatePlinkSettings(settingsData) {
		return this.httpClient.post('/plinks/updatePlinkSettings', settingsData, {
			observe: "body"
		});
	}

	getPlinksListing(customerId, siteId, noUIBlock, option) {
		return this.httpClient.post('/plinks/getPlinksListing', {customerId, siteId, option}, {
			observe: "body",
			params: new NoUIBlockHttpParams(noUIBlock)
		});
	}

	fetchPlinkData(payLoadObject) {
		var noUIBlock = false;
		if(payLoadObject.from == 'MostRecent')
			noUIBlock = true;

		return this.httpClient.post('/plinks/fetchPlinkData', payLoadObject, {
			observe: "body",
			// params: new NoUIBlockHttpParams(noUIBlock)
		});
	}

	addCommandToPlinkQueue(id, command, options = {}) {
		return this.httpClient.post('/plinks/addCommandToPlinkQueue', {id, command, options}, {
			observe: "body"
		});
	}

	getPolarLinkEvents(polarlinkID, fromDate, toDate, ssid){
		return this.httpClient.post('/plinks/getPolarLinkEvents', {id: polarlinkID, fromDate, toDate, ssid}, {
			observe: "body",
			// params: new NoUIBlockHttpParams(noUIBlock)
		});
	}

	getPolarLinkDebugRecords(polarlinkID, fromDate, toDate){
		return this.httpClient.post('/plinks/getPolarLinkDebugRecords', {id: polarlinkID, fromDate, toDate}, {
			observe: "body",
			// params: new NoUIBlockHttpParams(noUIBlock)
		});
	}

	// Stage 2: Get PolarLink QuickView data
	getPolarLinkQuickView(deviceId: number, blockUI: boolean = false) {
		return this.httpClient.post('/plinks/getPolarLinkQuickView', {id: deviceId}, {
			observe: "body",
			params: blockUI ? {} : new NoUIBlockHttpParams(true)
		});
	}

	/**
	 * Add fetch PolarLink RT records request
	 * STUB SERVICE METHOD - Not fully implemented
	 * Similar to battview addFetchBattviewRTrecordsRequest service method
	 * @param id - PolarLink device ID (should be deviceid, not old id field)
	 * @param startDate - Start date timestamp
	 * @param endDate - End date timestamp
	 * @returns Observable with request result
	 */
	addFetchPolarLinkRTrecordsRequest(id, startDate, endDate) {
		console.log('STUB: addFetchPolarLinkRTrecordsRequest service method called');
		console.log('STUB: Parameters:', {id, startDate, endDate});

		return this.httpClient.post('/plinks/addFetchPolarLinkRTrecordsRequest', {id, startDate, endDate}, {
			observe: "body",
			responseType: 'text'
		});
	}

	/**
	 * Get fetch PolarLink RT records request status
	 * STUB SERVICE METHOD - Not fully implemented
	 * Similar to battview getFetchRTrecordsRequest functionality
	 * @param id - PolarLink device ID (should be deviceid, not old id field)
	 * @returns Observable with request status
	 */
	getFetchPolarLinkRTrecordsRequest(id) {
		console.log('STUB: getFetchPolarLinkRTrecordsRequest service method called');
		console.log('STUB: Device ID:', id);

		return this.httpClient.post('/plinks/getFetchPolarLinkRTrecordsRequest', {id}, {
			observe: "body"
		});
	}

	/**
	 * Check if PolarLink RT records exist
	 * STUB SERVICE METHOD - Not fully implemented
	 * Similar to battview checkIfRTrecordsExist service method
	 * @param id - PolarLink device ID (should be deviceid, not old id field)
	 * @param studyId - Study ID (optional, defaults to 0)
	 * @returns Observable with existence check result
	 */
	checkIfPolarLinkRTrecordsExist(id, studyId = 0) {
		console.log('STUB: checkIfPolarLinkRTrecordsExist service method called');
		console.log('STUB: Parameters:', {id, studyId});

		return this.httpClient.post('/plinks/checkIfPolarLinkRTrecordsExist', {id, studyId}, {
			observe: "body"
		});
	}
}
